var map = {
	"./Cerasuolo.png": 69212,
	"./TipideiVini.png": 40531,
	"./TipideiViniCircleW250.png": 26199,
	"./TipologiaWd1200.png": 66927,
	"./TipologiaWd1600.png": 57867,
	"./TipologiaWd2000.png": 92720,
	"./TipologiaWd350.png": 61372,
	"./TipologiaWd3500.png": 43078,
	"./TipologiaWd500.png": 86349,
	"./TipologiaWd800.png": 95312,
	"./VinificazioneCerasuoloCircleW250.png": 73848,
	"./VinificazioneInBianco.png": 42948,
	"./VinificazioneInBiancoCircleW250.png": 69748,
	"./VinificazioneInRosso.png": 8152,
	"./VinificazioneInRossoCircleW250.png": 84952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83709;